export default "__VITE_ASSET__DQqqKQaV__"